import { createAction, props } from '@ngrx/store';
import { CarRefItemStatus } from 'src/app/public/car/constants/car-basic-data';
import { CarEngine } from 'src/app/public/car/models/car-engine.model';
import { CarFeature } from 'src/app/public/car/models/car-feature.model';
import { CarJobTask } from 'src/app/public/car/models/car-job-task.model';
import { CarJobTemplate } from 'src/app/public/car/models/car-job-template.model';
import { CarMake } from 'src/app/public/car/models/car-make.model';
import { CarManufacturer } from 'src/app/public/car/models/car-manufacturer.model';
import { CarModel } from 'src/app/public/car/models/car-model.model';
import { CarVersion } from 'src/app/public/car/models/car-version.model';



export class CarRefActions {

    // Manufacturers 

    public static manufacturerNewSubmit = createAction(
        '[Car Component] manufacturer New Submit',
        props <{ manufacturer: CarManufacturer }> ()
    );

    public static manufacturerNewSuccess = createAction(
        '[Car Component] manufacturer New Success',
        props <{ manufacturer: CarManufacturer }> ()
    );

    public static manufacturerUpdateSubmit = createAction(
        '[Car Component] manufacturer Update Submit',
        props <{ manufacturer: CarManufacturer }> ()
    );

    public static manufacturerStatusUpdateSubmit = createAction(
        '[Car API] Update manufacturer status submit',
        props <{ manufacturerId: number, status: CarRefItemStatus }> ()
    );

    public static manufacturerUpdateSuccess = createAction(
        '[Car Component] manufacturer Update Success',
        props <{ manufacturer: CarManufacturer }> ()
    );

    public static manufacturerDeleteSubmit = createAction(
        '[Car Component] manufacturer Delete Submit',
        props <{ manufacturerId: number }> ()
    );

    public static manufacturerDeleteSuccess = createAction(
        '[Car Component] manufacturer Delete Success',
        props <{ manufacturerId: number }> ()
    );

    public static manufacturersFetchSubmit = createAction(
        '[SearchCriteria Component] Fetch Manufacturers Submit'
    );

    public static manufacturersFetchSuccess = createAction(
        '[SearchCriteria Component] Fetch Manufacturers Success',
        props <{ manufacturers: CarManufacturer [] }> ()
    );


     // Makes 

     public static makeNewSubmit = createAction(
        '[Car Component] make New Submit',
        props <{ make: CarMake }> ()
    );

    public static makeNewSuccess = createAction(
        '[Car Component] make New Success',
        props <{ make: CarMake }> ()
    );

    public static makeUpdateSubmit = createAction(
        '[Car Component] make Update Submit',
        props <{ make: CarMake }> ()
    );

    public static makeStatusUpdateSubmit = createAction(
        '[Car API] Update make status submit',
        props <{ makeId: number, status: CarRefItemStatus }> ()
    );

    public static makeUpdateSuccess = createAction(
        '[Car Component] make Update Success',
        props <{ make: CarMake }> ()
    );

    public static makeDeleteSubmit = createAction(
        '[Car Component] make Delete Submit',
        props <{ makeId: number }> ()
    );

    public static makeDeleteSuccess = createAction(
        '[Car Component] make Delete Success',
        props <{ makeId: number }> ()
    );

    public static makesFetchAllSubmit = createAction(
        '[SearchCriteria Component] Fetch Makes Submit'
    );

    public static makesFetchSubmit = createAction(
        '[SearchCriteria Component] Fetch Makes Submit',
        props <{ manufacturerIds?: number[] }> ()
    );

    public static makesFetchSuccess = createAction(
        '[SearchCriteria Component] Fetch Makes Success',
        props <{ makes: CarMake [] }> ()
    );


     // Models 

     public static modelNewSubmit = createAction(
        '[Car Component] model New Submit',
        props <{ model: CarModel }> ()
    );

    public static modelNewSuccess = createAction(
        '[Car Component] model New Success',
        props <{ model: CarModel }> ()
    );

    public static modelUpdateSubmit = createAction(
        '[Car Component] model Update Submit',
        props <{ model: CarModel }> ()
    );

    public static modelStatusUpdateSubmit = createAction(
        '[Car API] Update model status submit',
        props <{ modelId: number, status: CarRefItemStatus }> ()
    );

    public static modelUpdateSuccess = createAction(
        '[Car Component] model Update Success',
        props <{ model: CarModel }> ()
    );

    public static modelDeleteSubmit = createAction(
        '[Car Component] model Delete Submit',
        props <{ modelId: number }> ()
    );

    public static modelDeleteSuccess = createAction(
        '[Car Component] model Delete Success',
        props <{ modelId: number }> ()
    );

    public static modelsFetchAllSubmit = createAction(
        '[SearchCriteria Component] Fetch Models Submit'
    );

    public static modelsFetchSubmit = createAction(
        '[SearchCriteria Component] Fetch Models Submit',
        props <{ makeIds?: number[] }> ()
    );

    public static modelsFetchSuccess = createAction(
        '[SearchCriteria Component] Fetch Models Success',
        props <{ models: CarModel [] }> ()
    );


     // Versions 

     public static versionNewSubmit = createAction(
        '[Car Component] version New Submit',
        props <{ version: CarVersion }> ()
    );

    public static versionNewSuccess = createAction(
        '[Car Component] version New Success',
        props <{ version: CarVersion }> ()
    );

    public static versionUpdateSubmit = createAction(
        '[Car Component] version Update Submit',
        props <{ version: CarVersion }> ()
    );

    public static versionStatusUpdateSubmit = createAction(
        '[Car API] Update version status submit',
        props <{ versionId: number, status: CarRefItemStatus }> ()
    );

    public static versionUpdateSuccess = createAction(
        '[Car Component] version Update Success',
        props <{ version: CarVersion }> ()
    );

    public static versionDeleteSubmit = createAction(
        '[Car Component] version Delete Submit',
        props <{ versionId: number }> ()
    );

    public static versionDeleteSuccess = createAction(
        '[Car Component] version Delete Success',
        props <{ versionId: number }> ()
    );

    public static versionsFetchAllSubmit = createAction(
        '[SearchCriteria Component] Fetch Versions Submit'
    );

    public static versionsFetchSubmit = createAction(
        '[SearchCriteria Component] Fetch Versions Submit',
        props <{ modelIds?: number[] }> ()
    );

    public static versionsFetchSuccess = createAction(
        '[SearchCriteria Component] Fetch Versions Success',
        props <{ versions: CarVersion [] }> ()
    );


     // Engines 

     public static engineNewSubmit = createAction(
        '[Car Component] engine New Submit',
        props <{ engine: CarEngine }> ()
    );

    public static engineNewSuccess = createAction(
        '[Car Component] engine New Success',
        props <{ engine: CarEngine }> ()
    );

    public static engineUpdateSubmit = createAction(
        '[Car Component] engine Update Submit',
        props <{ engine: CarEngine }> ()
    );

    public static engineStatusUpdateSubmit = createAction(
        '[Car API] Update engine status submit',
        props <{ engineId: number, status: CarRefItemStatus }> ()
    );

    public static engineUpdateSuccess = createAction(
        '[Car Component] engine Update Success',
        props <{ engine: CarEngine }> ()
    );

    public static engineDeleteSubmit = createAction(
        '[Car Component] engine Delete Submit',
        props <{ engineId: number }> ()
    );

    public static engineDeleteSuccess = createAction(
        '[Car Component] engine Delete Success',
        props <{ engineId: number }> ()
    );

    public static enginesFetchAllSubmit = createAction(
        '[SearchCriteria Component] Fetch Engines Submit'
    );

    public static enginesFetchSubmit = createAction(
        '[SearchCriteria Component] Fetch Engines Submit',
        props <{ manufacturerIds?: number[] }> ()
    );

    public static enginesFetchSuccess = createAction(
        '[SearchCriteria Component] Fetch Engines Success',
        props <{ engines: CarEngine [] }> ()
    );

    
     // Features 

    public static featureNewSubmit = createAction(
        '[Car Component] feature New Submit',
        props <{ feature: CarFeature }> ()
    );

    public static featureNewSuccess = createAction(
        '[Car Component] feature New Success',
        props <{ feature: CarFeature }> ()
    );

    public static featureUpdateSubmit = createAction(
        '[Car Component] feature Update Submit',
        props <{ feature: CarFeature }> ()
    );

    public static featureStatusUpdateSubmit = createAction(
        '[Car API] Update feature status submit',
        props <{ featureId: number, status: CarRefItemStatus }> ()
    );

    public static featureUpdateSuccess = createAction(
        '[Car Component] feature Update Success',
        props <{ feature: CarFeature }> ()
    );

    public static featureDeleteSubmit = createAction(
        '[Car Component] feature Delete Submit',
        props <{ featureId: number }> ()
    );

    public static featureDeleteSuccess = createAction(
        '[Car Component] feature Delete Success',
        props <{ featureId: number }> ()
    );

    public static featuresFetchAllSubmit = createAction(
        '[SearchCriteria Component] Fetch Features Submit'
    );

    public static featuresFetchSubmit = createAction(
        '[SearchCriteria Component] Fetch Features Submit',
        props <{ manufacturerIds?: number[] }> ()
    );

    public static featuresFetchSuccess = createAction(
        '[SearchCriteria Component] Fetch Features Success',
        props <{ features: CarFeature [] }> ()
    );


  
     // JobTemplates 

     public static jobTemplateNewSubmit = createAction(
        '[Car Component] jobTemplate New Submit',
        props <{ jobTemplate: CarJobTemplate }> ()
    );

    public static jobTemplateNewSuccess = createAction(
        '[Car Component] jobTemplate New Success',
        props <{ jobTemplate: CarJobTemplate }> ()
    );

    public static jobTemplateUpdateSubmit = createAction(
        '[Car Component] jobTemplate Update Submit',
        props <{ jobTemplate: CarJobTemplate }> ()
    );

    public static jobTemplateStatusUpdateSubmit = createAction(
        '[Car API] Update jobTemplate status submit',
        props <{ jobTemplateId: number, status: CarRefItemStatus }> ()
    );

    public static jobTemplateUpdateSuccess = createAction(
        '[Car Component] jobTemplate Update Success',
        props <{ jobTemplate: CarJobTemplate }> ()
    );

    public static jobTemplateDeleteSubmit = createAction(
        '[Car Component] jobTemplate Delete Submit',
        props <{ jobTemplateId: number }> ()
    );

    public static jobTemplateDeleteSuccess = createAction(
        '[Car Component] jobTemplate Delete Success',
        props <{ jobTemplateId: number }> ()
    );

    public static jobTemplatesFetchAllSubmit = createAction(
        '[SearchCriteria Component] Fetch JobTemplates Submit'
    );

    public static jobTemplatesFetchSubmit = createAction(
        '[SearchCriteria Component] Fetch JobTemplates Submit',
        props <{ jobTemplateIds?: number[] }> ()
    );

    public static jobTemplatesFetchSuccess = createAction(
        '[SearchCriteria Component] Fetch JobTemplates Success',
        props <{ jobTemplates: CarJobTemplate [] }> ()
    );


     
     // JobTasks 

     public static jobTaskNewSubmit = createAction(
        '[Car Component] jobTask New Submit',
        props <{ jobTask: CarJobTask }> ()
    );

    public static jobTaskNewSuccess = createAction(
        '[Car Component] jobTask New Success',
        props <{ jobTask: CarJobTask }> ()
    );

    public static jobTaskUpdateSubmit = createAction(
        '[Car Component] jobTask Update Submit',
        props <{ jobTask: CarJobTask }> ()
    );

    public static jobTaskStatusUpdateSubmit = createAction(
        '[Car API] Update jobTask status submit',
        props <{ jobTaskId: number, status: CarRefItemStatus }> ()
    );

    public static jobTaskUpdateSuccess = createAction(
        '[Car Component] jobTask Update Success',
        props <{ jobTask: CarJobTask }> ()
    );

    public static jobTaskDeleteSubmit = createAction(
        '[Car Component] jobTask Delete Submit',
        props <{ jobTaskId: number }> ()
    );

    public static jobTaskDeleteSuccess = createAction(
        '[Car Component] jobTask Delete Success',
        props <{ jobTaskId: number }> ()
    );

    public static jobTasksFetchAllSubmit = createAction(
        '[SearchCriteria Component] Fetch JobTasks Submit'
    );

    public static jobTasksFetchSubmit = createAction(
        '[SearchCriteria Component] Fetch JobTasks Submit',
        props <{ jobTaskIds?: number[] }> ()
    );

    public static jobTasksFetchSuccess = createAction(
        '[SearchCriteria Component] Fetch JobTasks Success',
        props <{ jobTasks: CarJobTask [] }> ()
    );

}

